import React from 'react'
import { Spin, Icon } from 'antd'

export default () => (
  <div style={{marginLeft: '1rem', marginTop: '1rem'}}>
    <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Loading/index.js